export default __webpack_public_path__ + "static/media/GroupLock.2796e18a.svg";